import React, { useState } from 'react';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import { useFormContext } from 'react-hook-form';
import Label from '@/components/form/Label/Label';
import SelectField from '@/components/form/SelectField/SelectField';
import TextField from '@/components/form/TextField/TextField';
import { useCrieSeuRoteiroContext } from '@/features/forms/CrieSeuRoteiro/context';
import {
  TRAVEL_BUDGET_OPTIONS,
  TRAVEL_EXPERIENCIES_OPTIONS,
  TRAVEL_REASON_OPTIONS,
} from '@/features/forms/CrieSeuRoteiro/data';
import dayjs from 'dayjs';
import MultiSelectControlled from '@/components/form/MultiSelect/MultiSelectControlled';
import Radio from '@/components/form/Radio/Radio';
import RadioGroup from '@/components/form/RadioGroup/RadioGroup';
import { FlexElement } from '@/features/forms/CrieSeuRoteiro/CrieSeuRoteiro.styles';
import { type FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';
import { type ActionMeta } from 'react-select';
import { type SelectOptionType } from '@/components/form/MultiSelect/MultiSelect';

const FormTravelData = ({ ...props }) => {
  const {
    control,
    register,
    formState: { errors },
    ...methods
  } = useFormContext<FormCreateJourneyDataType>();

  const { watch } = methods;

  const { data } = useCrieSeuRoteiroContext();
  const { destinos, cidades } = data;
  const [cidadeOptions, setCidadeOptions] = useState<SelectTravelCitiesToVisitValue[]>(cidades);

  const handleOnSelect = (option: [SelectTravelDestinationValue], actionMeta: ActionMeta<SelectOptionType>) => {
    const destinoIds = option.map((i) => i.id);
    if (destinoIds.length) {
      setCidadeOptions((prevState) => [
        ...cidades.filter((c: SelectTravelCitiesToVisitValue) => destinoIds.includes(c.destino_id)),
      ]);
    } else {
      setCidadeOptions((prevState) => cidades);
    }
  };
  return (
    <>
      {/*<Banner show={Object.keys(errors).length > 0} appearance="error" size="large">*/}
      {/*  <Text align="center" weight="bold">*/}
      {/*    Por favor, corrigir o(s) erro(s) abaixo:*/}
      {/*  </Text>*/}
      {/*</Banner>*/}
      <Fieldset size="lg" align="center">
        <legend>Informe os dados da sua viagem</legend>
        <FlexElement>
          <FieldGroup>
            <Label htmlFor="travelReason" required>
              Motivo da viagem
            </Label>
            <SelectField id="travelReason" error={errors.travelReason?.message} {...register('travelReason')}>
              <option value="">-- selecione --</option>
              {TRAVEL_REASON_OPTIONS.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </SelectField>
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor="travelPlannedDate" required>
              Data prevista
            </Label>
            <TextField
              id="travelPlannedDate"
              type="date"
              error={errors.travelPlannedDate?.message}
              autoCapitalize="off"
              {...register('travelPlannedDate')}
              min={dayjs().add(7, 'days').format('YYYY-MM-DD')}
              max={dayjs().add(2, 'years').format('YYYY-MM-DD')}
            />
          </FieldGroup>
        </FlexElement>

        <FieldGroup>
          <Label htmlFor="travelDestinations" required>
            Destino(s) que deseja visitar
          </Label>
          <MultiSelectControlled
            name="travelDestinations"
            // @ts-expect-error Invalid
            control={control}
            error={errors.travelDestinations?.message}
            onSelect={handleOnSelect}
            options={destinos.map((destino) => ({ label: destino.title, value: destino.title, id: destino.id }))}
          />
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelCitiesToVisit">Cidade(s) que deseja visitar</Label>
          <MultiSelectControlled
            name="travelCitiesToVisit"
            // @ts-expect-error Invalid
            control={control}
            error={errors.travelCitiesToVisit?.message}
            options={cidadeOptions.map((cidade) => ({ label: cidade.title, value: cidade.title }))}
          />
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelExperiencies" required>
            Experiências que lhe agradam
          </Label>
          <MultiSelectControlled
            name="travelExperiencies"
            // @ts-expect-error Invalid
            control={control}
            error={errors.travelExperiencies?.message}
            options={TRAVEL_EXPERIENCIES_OPTIONS.map((item) => ({ label: item, value: item }))}
          />
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelBudget" required>
            Orçamento por pessoa em reais (R$)
          </Label>
          <SelectField id="travelBudget" error={errors.travelBudget?.message} {...register('travelBudget')}>
            <option value="">-- selecione --</option>
            {TRAVEL_BUDGET_OPTIONS.filter((item, index) => {
              const items = watch('travelDestinations');
              const found = [...items].map((item) => item.value);
              if (index === 0) {
                return found.includes('Brasil');
              }
              return true;
            }).map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </SelectField>
        </FieldGroup>

        <FlexElement>
          <RadioGroup label="Você fala inglês?">
            <Radio label="Sim" value="Sim" {...register('travelSpeakEng')} />
            <Radio label="Não" value="Nāo" {...register('travelSpeakEng')} />
          </RadioGroup>
          <RadioGroup label="Idioma de preferência" labelInfo="(sujeito à disponibilidade)">
            <Radio label="Inglês" value="Inglês" {...register('travelLangPref')} />
            <Radio label="Espanhol" value="Espanhol" {...register('travelLangPref')} />
          </RadioGroup>
        </FlexElement>
      </Fieldset>
    </>
  );
};

export default FormTravelData;
